import Link from "@whoppah/next/link";

import Image from "@/components/common/Image";
import { MegaMenuMobileActionProps } from "@/components/mega-menu/mobile/MegaMenuMobileActionDelegator";
import { useSellRoute } from "@/features/us-market/hooks/useSellRoute";
import { Flavor } from "@/ui/typography/Flavor";

export const MegaMenuMobileSellAction = ({
  onClick,
  children,
  icon,
}: MegaMenuMobileActionProps) => {
  const { href: sellHref } = useSellRoute("mobile_menu");

  return (
    <li>
      <Link
        href={sellHref}
        className="flex items-center space-x-2"
        onClick={onClick}
      >
        <div className="relative h-4 w-4">
          <Image
            src={icon}
            alt="Sell"
            layout="fill"
            objectFit="contain"
            priority={true}
          />
        </div>
        <Flavor>{children}</Flavor>
      </Link>
    </li>
  );
};
